import { Component } from '@angular/core';

@Component({
  selector: 'region-icon',
  standalone: true,
  imports: [],
  templateUrl: './region.component.html',
  styleUrl: './region.component.scss'
})
export class RegionIcon {}